let htmlClass = require('./html-class-toggle');

module.exports = {
	mixins: [htmlClass],

	data() {
		return {
			offCanvasOpen: {
				left: false,
				right: false
			}
		}
	},

	methods: {
    	toggleOffCanvas(side) {
    		if(!this.offCanvasOpen[side]) {
    			this.openOffCanvas(side);
    		} else {
    			this.closeOffCanvas(side);
    		}
    	},

    	openOffCanvas(side) {
			this.offCanvasOpen[side] = true;
			this.toggleHtmlClass('off-canvas-open');
			this.toggleHtmlClass('off-canvas-open-' + side);
    	},

    	closeOffCanvas(side) {
    		this.offCanvasOpen[side] = false;
			this.toggleHtmlClass('off-canvas-open', false);
			this.toggleHtmlClass('off-canvas-open-' + side, false);
    	},

    	closeAllOffCanvas() {
    		this.closeOffCanvas('left');
    		this.closeOffCanvas('right');
    	}
	}
}
